import { Module } from "wrapper6";
import Swiper from 'swiper/bundle';

import 'core-js/es6/number';


var $ = jQuery;

export default class SingleLexicon extends Module {

	ready(app) {

        if (document.querySelector('.mtt-lexicon-cover__image-wrapper')) {
            this.galleryThumbs = new Swiper('.gallery-thumbs', {
                spaceBetween: 10,
                slidesPerView: 3,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
            });

            if (this.galleryThumbs.slides.length === 1) {
                const THUMBS = document.querySelector('.gallery-thumbs');
                const BTNS =  document.querySelector('.mtt-lexicon-cover__swiper-container').querySelectorAll('.swiper-button');
                THUMBS.classList.add('hide');
               
                if (BTNS) {
                    for (let i = 0; i < BTNS.length; i++) {
                        const BTN = BTNS[i];
                        
                        BTN.classList.add('hide');
                    }
                }
            }
    
            this.galleryTop = new Swiper('.gallery-top', {
                spaceBetween: 10,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                thumbs: {
                    swiper: this.galleryThumbs
                }
            });   
        }

        this.linkToImage();
    }


    linkToImage() {
        const BUTTONS = document.querySelectorAll('.link-to-img');

        if (BUTTONS) {
            for (let i = 0; i < BUTTONS.length; i++) {
                const BUTTON = BUTTONS[i];
                
                BUTTON.addEventListener('click', () => {
                    let NUMBER = BUTTON.getAttribute('data-number');
                    NUMBER = parseInt(NUMBER) - 1;

                    if (this.galleryTop.slides[NUMBER]) {                        
                        this.galleryTop.slideTo(NUMBER);                       
                    }                                        
                });
            }
        }
    }
}